import { NameDto } from 'api/Common/Types'
import { GroupReferenceDto } from 'api/Common/Types/GroupReferenceDto'
import { TicketsViewType } from 'routes/Tickets/TicketsViewType'
import { TransactionStatus } from 'utils/transaction/status.index'

export interface TicketDto {
  id: string
  referenceId: string | null
  kind: string
  number: number
  description: string
  assignee: {
    id: string
    name: string
  } | null
  client: {
    id: string
    name: string
    country: {
      id: string | null
      name: string | null
    }
  }
  source: {
    id: number
    name: string
  }
  status: {
    id: number
    name: string
  }
  type: {
    id: number
    name: string
  }
  departments: {
    id: number
    name: string
  }[]
  selected: boolean
  exclamationMarkIcon: boolean
  viewType: {
    id: TicketsViewType
    name: string
  }
  lead?: {
    country: {
      id: string
      name: string
    }
    id: string
    name: string
    phoneNumber: string
    tickmillCompnay: {
      id: number
      name: string
    }
  }
  data: TicketPaymentsDto | {}
}

export interface TicketPaymentsDto extends TicketDto {
  transaction: {
    id: string
    name: string
    transactionState: NameDto<TransactionStatus>
    groupReferences?: GroupReferenceDto[]
    canBulkProcess?: boolean
    mlStatus?: NameDto
  }
}

export const isTicketPayments = (ticketDto: TicketDto): ticketDto is TicketPaymentsDto => {
  return 'transaction' in ticketDto.data
}

export const isTicketsPayments = (ticketDto: TicketDto[]): ticketDto is TicketPaymentsDto[] => {
  return ticketDto.every((x) => isTicketPayments(x))
}

export enum TicketKey {
  ID = 'id',
  LEAD = 'lead.name',
  NUMBER = 'number',
  TYPE = 'type.name',
  action = 'action',
  VIEWTYPE = 'viewType.name',
  GROUP_REFERENCE = 'data.transaction.groupReferences[0].name',
  BULK_PROCESS_ELIGIBLE = 'data.transaction.canBulkProcess',
  ML_STATUS = 'data.transaction.mlStatus.name',
  REFERENCE = 'referenceId',
  CLIENT = 'client.name',
  COUNTRY = 'client.country.name',
  LEAD_COUNTRY = 'lead.country.name',
  TICKMILL_COMPANY = 'client.tickmillCompany.name',
  LEAD_TICKMILL_COMPANY = 'lead.tickmillCompany.name',
  STATUS = 'status.name',
  TRANSACTION_STATUS = 'data.transaction.transactionState.name',
  ASSIGNEE = 'assignee.name',
  REPORTER = 'reporter.name',
  DESCRIPTION = 'description',
  DATE_CREATED = 'createDate',
  DATE_UPDATED = 'updateDate',
  COMMENT = 'comment',
}

export enum TicketFilterKey {
  NUMBER = 'Number',
  TYPE = 'Type',
  VIEWTYPE = 'ViewType',
  REFERENCE = 'Reference',
  BULK_REFERENCE = 'BulkReferenceName',
  GROUP_ID = 'GroupId',
  GROUP_REFERENCE_ID = 'GroupReferenceId',
  BULK_PROCESS_ELIGIBLE = 'CanBulkProcess',
  ML_STATUS = 'MLStatusId',
  CLIENT = 'Client',
  COUNTRY = 'Country',
  TICKMILL_COMPANY = 'TickmillCompany',
  STATUS = 'Status',
  TRANSACTION_STATUS = 'TransactionStateId',
  ASSIGNEE = 'Assignee',
  DESCRIPTION = 'Description',
  REPORTER = 'Reporter',
  DATE_CREATED = 'DateTimeCreated',
  DATE_UPDATED = 'DateTimeUpdated',
  PAYMENT_PROVIDER = 'PaymentProvider',
  IS_INTERNAL_TEST_ACCOUNT = 'IsInternalTestAccount',
}

export enum TicketSortKey {
  NUMBER = 'Number',
  TYPE = 'Type',
  VIEWTYPE = 'ViewType',
  REFERENCE = 'Reference',
  BULK_REFERENCE = 'BulkReferenceName',
  CLIENT = 'Client',
  COUNTRY = 'Country',
  TICKMILL_COMPANY = 'TickmillCompany',
  STATUS = 'Status',
  TRANSACTION_STATUS = 'TransactionStateId',
  ASSIGNEE = 'Assignee',
  DESCRIPTION = 'Description',
  DATE_CREATED = 'CreatedDate',
  DATE_UPDATED = 'UpdatedDate',
  PAYMENT_PROVIDER = 'PaymentProvider',
  IS_INTERNAL_TEST_ACCOUNT = 'IsInternalTestAccount',
}
